import { defineMessage } from "react-intl";

/* Rental area booking states */
export const RENTAL_AREAS_AVAILABILITIES_STATES_VALUE_AVAILABLE = "available";
export const RENTAL_AREAS_AVAILABILITIES_STATES_VALUE_UNAVAILABLE =
  "unavailable";
export const RENTAL_AREAS_AVAILABILITIES_STATES_VALUE_BOOKED = "booked";

/**
 * @type {Record<import("../../types/rentalArea/Availability").RentalAreaAvailabilityState, {
 * id: import("../../types/rentalArea/Availability").RentalAreaAvailabilityState;
 * label: import("react-intl").MessageDescriptor;
 * }>}
 */
export const RENTAL_AREAS_AVAILABILITIES_STATES = {
  [RENTAL_AREAS_AVAILABILITIES_STATES_VALUE_AVAILABLE]: {
    id: RENTAL_AREAS_AVAILABILITIES_STATES_VALUE_AVAILABLE,
    label: defineMessage({ defaultMessage: "disponible" }),
  },
  [RENTAL_AREAS_AVAILABILITIES_STATES_VALUE_UNAVAILABLE]: {
    id: RENTAL_AREAS_AVAILABILITIES_STATES_VALUE_UNAVAILABLE,
    label: defineMessage({ defaultMessage: "indisponible" }),
  },
};

export const RENTAL_AREAS_AVAILABILITIES_STATES_LIST = Object.values(
  RENTAL_AREAS_AVAILABILITIES_STATES,
);
